/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TOGGLE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    checkbox: {
        height: pxToEm(24),
        width: pxToEm(24),
        border: replacePXinStringWithEM(`2px solid #EEF2F6`),
        borderRadius: pxToEm(4),
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        extend: themeStyleHelper(theme, 'color', (theme, uniqueColor)=>{
            return {
                backgroundColor: theme.color[uniqueColor].medium.swatch,
                color: theme.color[uniqueColor].medium.contrast
            }
        }),
        '&.active-false':{
            '& .name-check':{
                opacity: 0,
                transition: 'all .05s ease-out 0s'
            }
        },
        '&.active-true':{
            '& .name-check':{
                opacity: 1,
                transition: 'all .05s ease-in 0s'
            }
        }
    }
});
